import {createContext} from "react";

// This context stores the execution tree instance information.
const ExecutionTreeInstanceContext = createContext();

export default ExecutionTreeInstanceContext;
